<template>
  <div class="customer-access-menu">
    <v-list
      dense
      class="menu-static-list"
    >
      <v-list-item
        v-for="(item, index) in filteredMenuItems"
        :key="index"
        :to="{ name: item.routeName }"
        router
        exact
        @click="trackMenu(item.trackName)"
      >
        <v-list-item-action class="mr-2">
          <component
            :is="item.icon"
            :size="20"
          />
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
// Tracking
import mixpanel from 'mixpanel-browser';

export default {
  name: 'MenuStaticCustomerAccess',

  inject: ['appData'],

  data() {
    return {};
  },

  methods: {
    trackMenu(trackName) {
      mixpanel.track('click', {
        button_name: trackName
      });
    }
  },

  computed: {
    menuItems() {
      return [
        {
          title: this.$t('menu.customerItems.home'),
          icon: 'PhHouse',
          routeName: 'CustomerAccessHome',
          trackName: 'menu_customer_access_home',
          allowAccess: true
        },
        {
          title: this.$t('menu.customerItems.myAccount'),
          icon: 'PhUser',
          routeName: 'CustomerAccessAccount',
          trackName: 'menu_customer_access_account',
          allowAccess: true
        },
        {
          title: this.$t('menu.customerItems.myOperations'),
          icon: 'PhFileText',
          routeName: 'CustomerAccessOperationReport',
          trackName: 'menu_customer_access_operation_report',
          allowAccess: true
        },
        {
          title: this.$t('menu.customerItems.myWallets'),
          icon: 'PhWallet',
          routeName: 'CustomerAccessWallets',
          trackName: 'menu_customer_access_wallets',
          allowAccess: true
        },
        {
          title: this.$t('menu.customerItems.newOperation'),
          icon: 'PhPlus',
          routeName: 'CustomerAccessOperations',
          trackName: 'menu_customer_access_operations',
          allowAccess: this.appData.currentUser.canOperate
        }
      ];
    },

    filteredMenuItems() {
      return this.menuItems.filter((i) => i.allowAccess);
    }
  }
};
</script>

<style lang="scss" scoped>
.customer-access-menu {
  padding-top: 8px;
}
</style>
